import React from 'react'
import PropTypes from 'prop-types'
import { SubwebForm, Toast } from 'containers'
import { useQuery, useMutation, queryCache } from 'react-query'
import { getSubwebInfo, putSubweb, SUBWEB_KEY } from 'services/requests'
import { Error } from 'components/organisms'
import { toast } from 'react-toastify';

const SubwebUpdateForm = ({ subweb }) => {
  const {
    isLoading,
    isError,
    data
  } = useQuery([SUBWEB_KEY, { subweb }], getSubwebInfo)

  const [updateSubweb, {
    isLoading: isLoadingUpdateSubweb
  }] = useMutation(putSubweb, {
    onSuccess: () => {
      queryCache.invalidateQueries(SUBWEB_KEY)
      toast.success(
        <Toast
          type="success"
          title="Subweb atualizada"
          description="Os dados da subweb foram gravados com sucesso."
        />
      );
    },
    onError: (err) => {
      toast.error(
        <Toast
          type="error"
          title="Erro a atualizar informações da subweb"
          description={err.message}
        />
      );
    }
  })

  const initialValues = React.useMemo(() => {
    if (data && data.data) return data.data
    return null
  }, [data])

  const handleSubmit = (values) => {
    updateSubweb({ subweb, ...values })
  }

  if (isLoading) {
    return <p>A carregar...</p>
  }

  if (isError) {
    return (
      <Error message="Erro a carregar dados da subweb" />
    )
  }

  return (
    <SubwebForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isLoading={isLoadingUpdateSubweb}
      showReset
      isEdit
    />
  )
}

SubwebUpdateForm.propTypes = {
  subweb: PropTypes.string.isRequired,
};

export default SubwebUpdateForm
